import React from 'react';
import { connect } from 'react-redux';
import { AppDispatch, WebsiteState } from '@gift/website-state/store';
import { useTranslation } from 'react-i18next';
import { TextStylingMenu } from './text-styling-menu/TextStylingMenu';
import { selectContentById, selectMaxLengthById, updateContentByIds } from './_redux';
import { selectNameByVariableId } from '@gift/website-state/slices/variablesSlice';
import { useToggle } from '@gift/ui/hooks/useToggle';
import { TextInputField } from '@gift/ui/components/input/text-input/TextInputField';
import { IconButton } from '@gift/ui/components/icon-button/IconButton';
import { Cell } from '@gift/ui/components/grid/Cell';
import { Grid } from '@gift/ui/components/grid/Grid';
import { Heading } from '@gift/ui/components/panel/Heading';
import { Panel } from '@gift/ui/components/panel/Panel';

const _TextInputControl = ({
    variableIds, name, value, onChange, maxLength
}: Props) => {
    const { t } = useTranslation();
    const [showOptions, toggleOptions] = useToggle();
    return (
        <Panel>
            {/* i18next-extract-disable-next-line */}
            <Heading>{t(name)}</Heading>
            <Grid gap='s'>
                <Cell>
                    <TextInputField type='text'
                        value={value}
                        commit={onChange}
                        maxLength={maxLength} />
                </Cell>
                <Cell fit>
                    <IconButton icon='text-style'
                        active={showOptions}
                        onClick={toggleOptions}
                        title={showOptions
                            ? t('text_input_control.collapse_options')
                            : t('text_input_control.expand_options')} />

                </Cell>
            </Grid>

            {showOptions && <TextStylingMenu variableIds={variableIds} />}
        </Panel>
    );
};

type Props = {
    variableIds: string[],
    name: string,
    maxLength: number,
    value: string,
    onChange: (value: string) => void
};

const mapStateToProps = (state: WebsiteState, ownProps: { variableIds: string[] }) => ({
    name: selectNameByVariableId(state, ownProps.variableIds[0])!,
    maxLength: selectMaxLengthById(state, ownProps.variableIds[0]!)!,
    value: selectContentById(state, ownProps.variableIds[0])!
});

const mapDispatchToProps = (dispatch: AppDispatch, ownProps: { variableIds: string[] }) => ({
    onChange: (value: string) => dispatch(updateContentByIds(ownProps.variableIds, value))
});

export const TextInputControl = connect(
    mapStateToProps,
    mapDispatchToProps,
)(_TextInputControl);
